import { AvailabilityMode } from '@m4a3/api-client';
import React, { Fragment } from 'react';
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid'

interface AvailabilityMenuProps {
  onChangeAvailabilityMode: (newMode: AvailabilityMode) => void;
  availabilityMode: AvailabilityMode;
  allowPause?: boolean;
}

export default function AvailabilityMenu(props: AvailabilityMenuProps) {
  const getAvailabilityChangeButtonForMode = (mode: AvailabilityMode) => {
    if (mode === AvailabilityMode.BUSY) {
      return (<MenuButton
        type="button"
        className="flex items-center gap-x-1.5 rounded-md px-3 py-2 text-sm font-semibold text-yellow-900 bg-yellow-100 shadow-sm ring-1 ring-inset ring-yellow-300 hover:bg-yellow-200"
      >
        Busy mode
        <ChevronDownIcon className="-mr-1 h-5 w-5 text-amber-400" aria-hidden="true" />
      </MenuButton>)

    }
    if (mode === AvailabilityMode.PAUSED) {
      return (<MenuButton
        type="button"
        className="flex items-center gap-x-1.5 rounded-md px-3 py-2 text-sm font-semibold text-red-900 bg-red-100 shadow-sm ring-1 ring-inset ring-red-300 hover:bg-red-200"
      >
        Paused mode
        <ChevronDownIcon className="-mr-1 h-5 w-5 text-red-400" aria-hidden="true" />
      </MenuButton>)

    }
    return (<MenuButton
      type="button"
      className="flex items-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
    >
      Normal mode
      <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
    </MenuButton>)
  }

  return <Menu as="div" className="relative">
    {getAvailabilityChangeButtonForMode(props.availabilityMode)}
    <Transition
      as={Fragment}
      enter="transition ease-out duration-100"
      enterFrom="transform opacity-0 scale-95"
      enterTo="transform opacity-100 scale-100"
      leave="transition ease-in duration-75"
      leaveFrom="transform opacity-100 scale-100"
      leaveTo="transform opacity-0 scale-95"
    >
      <MenuItems className="absolute right-0 z-10 mt-3 w-36 origin-top-right overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
        <div className="py-1">
          <MenuItem>
            {({ focus }) => (
              <button
                onClick={() => {
                  props.onChangeAvailabilityMode(AvailabilityMode.NORMAL);
                }}
                className={`${focus ? 'bg-gray-100 text-gray-900' : 'text-gray-700'} text-left	block px-4 py-2 text-sm`}
              >
                Normal
              </button>
            )}
          </MenuItem>
          <MenuItem>
            {({ focus }) => (
              <button
                onClick={() => {
                  props.onChangeAvailabilityMode(AvailabilityMode.BUSY);
                }}
                className={`${focus ? 'bg-gray-100 text-gray-900' : 'text-gray-700'} text-left	block px-4 py-2 text-sm`}
              >
                Busy (50% capacity)
              </button>
            )}
          </MenuItem>
          {props.allowPause && (<MenuItem>
            {({ focus }) => (
              <button
                onClick={() => {
                  props.onChangeAvailabilityMode(AvailabilityMode.PAUSED);
                }}
                className={`${focus ? 'bg-gray-100 text-gray-900' : 'text-gray-700'} text-left	block px-4 py-2 text-sm`}
              >
                Paused (no new orders)
              </button>
            )}
          </MenuItem>)}
        </div>
      </MenuItems>
    </Transition>
  </Menu>;
}
